import { useState,useEffect } from 'react';
import './header.scss';
import { Row } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import logo from '../../../../assets/icons/shield-logo.svg';
import slogan from '../../../../assets/icons/slogan.png';
import globe from '../../../../assets/icons/globe.svg';
import lifeSaver from '../../../../assets/icons/life_saver.svg';
import checkMark from '../../../../assets/icons/check-mark.svg';
import hamburgerMenu from '../../../../assets/icons/menu.svg';
import menorah from '../../../../assets/icons/menorah.svg';
import { SlidingPaneContent } from '../SlidingPaneContent';
import InformationStrip from '../InformationStrip/InformationStrip';
import Outlinelock from '../../../../assets/icons/outline-lock.svg';
import CloseX from '../../../../assets/icons/closeX.png';
import GovIlSite from '../../../../assets/icons/govilSite.png';
import HttpsSite from '../../../../assets/icons/httpsSite.png';
import Lock from '../../../../assets/icons/lock.png';
import OutlineCheckmarkCircle from '../../../../assets/icons/outline-checkmark-circle-2.svg';


declare function Translate(key: string): string;
declare var _siteSettings: any;
declare var _curLang: any;
declare function LoadTranslation(lang: string);

export let translateText = [
  {
      label: 'N_General_system_title_2',
      value: 'main header',
  },
  {
    label: 'N_General_system_security_check',
    value: 'main header link',
  },
  {
      label: 'N_General_close',
      value: 'close',
  },
  {
      label: 'N_General_system_security_subtitle_1',
      value: 'header block 1',
  },
  {
      label: 'N_General_system_security_info_1',
      value: 'paragraph 1',
  },
  
  {
      label: 'N_General_system_security_subtitle_2',
      value: 'header block 2',
  },
  {
      label: 'N_General_system_security_info_2',
      value: 'paragraph 2',
  },
  
  {
    label: 'N_General_system_security_info_2_1',
    value: 'paragraph 2 1'
  },
  {
    label: 'N_General_system_security_info_2_2',
    value: 'paragraph 2 2',
  },

  {
      label: 'N_General_system_security_info_2_3',
      value: 'paragraph 2 3',
  },
  {
      label: 'N_General_system_security_info_3',
      value: 'buttom header information strip',
  },
  {
      label: 'N_General_SignUp_lobby_info_5',
      value: 'israeli passport'
  },
  {
      label: 'N_General_SignUp_lobby_info_6',
      value: 'israeli ID'
  },
  {
      label: 'N_General_SignUp_lobby_info_7',
      value: 'israeli Immigrant certificate'
  },
  {
      label: 'N_General_SignUp_lobby_info_8',
      value: 'two questions'
  },
  {
      label: 'N_General_SignUp_lobby_info_9',
      value: 'credit card'
  },
  {
      label: 'N_General_SignUp_kupa_0',
      value: 'HMO'
  },
  {
      label: 'N_General_SignUp_lobby_info_11',
      value: 'Code of the Population Authority Clerk'
  },
  {
      label: 'N_General_SignUp_lobby_info_14',
      value: 'biometric passport details information'
  },
];

const Header = (props) => {  
  const [selectedLang, setSelectedLang] = useState(_curLang);
  const [isPaneOpen, setIsPaneOpen] = useState(false);
  
  const toggleSlidingPane = () => {
    setIsPaneOpen(!isPaneOpen);
  };

  const closeSlidingPane = () => {
    setIsPaneOpen(false);
    props.forceUpdate();
  };

  const changeLang = async (index: number) => {    
    setSelectedLang(_siteSettings.langs[index].toString());

    await LoadTranslation(_siteSettings.langs[index].toString());    
    props.forceUpdate()    
  };
    
  const helpRedirect = () => {
    window.open(_siteSettings.faqLink);
  };

  const handleHelpKeyDown = event => {
    if (event.code == "Enter" || event.code == "Space")
    {
      helpRedirect();
    }
  };

  const[showListInformatioStrip,setShowListInformatioStrip] = useState(false);

  const handleKeyDown = event => {
    if (event.code == "Enter" || event.code == "Space")
    {
      handleToggleClick(event);
    }
  };

  const handleToggleClick = (e) => {
    var informationstripDetails = document.getElementById("informationStreepDetails"); 

    if(informationstripDetails?.classList.contains("informationBoxHidden"))
    {
      informationstripDetails.classList.remove("informationBoxHidden");
      setTimeout(function() {
        informationstripDetails?.classList.remove("informationBoxVisuallyHidden");
      }, 20);

      document.getElementById('btnCloseInfoStrip')?.focus();
    }
    else
    {
      informationstripDetails?.classList.add("informationBoxVisuallyHidden");
      setTimeout(function() {
        informationstripDetails?.classList.add("informationBoxHidden");
      }, 500);

      document.getElementById('lnkOpenInfostrip')?.focus(); 
    }

    if(showListInformatioStrip){
      document.getElementById('lnkOpenInfostrip')?.setAttribute("aria-expanded","false");
    }
    else{
      document.getElementById('lnkOpenInfostrip')?.setAttribute("aria-expanded","true");
    }

    setShowListInformatioStrip(!showListInformatioStrip);       
  }
              
  var closeStrip = () => {      
    setShowListInformatioStrip(false);
  }
    
  return (
    <div className='root_header'>
      <div className='desktop'>
       <div style={{position:'relative'}}>
        <div
          className={
            'flex-row header-dir' +
            (props.showLogo
              ? ' justify-content-between flex-nowrap'
              : ' justify-content-end') +
            (props.isBiometricHeader
              ? ' biometric-header-container'
              : ' header-container')
          }
        >
          {props.showLogo ? (
            <div
              className={
                (_curLang === 'en' || _curLang === 'ru' ? 'ps-3 ' : 'pe-5 ') +
                'd-flex flex-row align-items-center' +
                (props.isBiometricHeader
                  ? ' col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12 biometric-header'
                  : '')
              } 
            >
              <img
                src={menorah}
                alt= {Translate("N_General_Accessibility_Alt_Menora_Icon")}
                className={
                  (_curLang === 'en' || _curLang === 'ru' ? 'me-4 ' : '') +
                  'ms-4 header-icon'
                }
              />
              <img src={logo} alt={Translate("N_General_Accessibility_Alt_Logo")}  className='bstrp-m-2 header-icon' />
              <div className='system_title_1'>
                {Translate('N_General_system_title_1')}
                <span
                  className='bstrp-m-2'
                  style={{
                    letterSpacing: '-2.5px',
                    fontWeight: 'lighter',
                    marginRight: '10px',
                  }}
                >                   
                </span>
              </div>  
              
              <img src={slogan}  style={{ height: '16px', width : '65px', margin: 'auto 8px' }} className='bstrp-m-2 header-icon' alt="" aria-hidden="true"/>            
            </div>
          ) : null}
          <div
            className={
              (_curLang === 'en' || _curLang === 'ru' ? 'pe-5 ' : 'ps-5 ') +
              'd-flex flex-row align-items-center' + 
              (props.isBiometricHeader
                ? ' justify-content-end col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12 biometric-header-lang'
                : '')
            }
          >
            <div className='d-flex headerItemsMargin informationStripPadding flex-row align-items-center'>
            <div className='informationStripDiv informationStripDivDeskTop'>
                <div className='mainHeader mainHeaderDesktop'>
                    <div className='flexContainer'>
                        <img src={Outlinelock} alt="" aria-hidden="true"/>
                        <div className='innerMainHeader'>
                            {Translate(translateText[0].label)}  
                        </div>
                        <div id="lnkOpenInfostrip" onClick={handleToggleClick} tabIndex={0} onKeyPress={handleKeyDown} 
                              className='innerMainHeader underLine bold pointerCursor' 
                              aria-haspopup='true' 
                              aria-expanded="false" 
                              aria-controls="informationStreepDetails"
                        >
                            {Translate(translateText[1].label)}
                        </div>
                        <div onClick={handleToggleClick} onKeyPress={handleKeyDown} aria-hidden="true" className={showListInformatioStrip ? 'arrowUpWhite' : 'arrowDownWhite'}></div>
                    </div>
                </div>
                
            </div>   
              </div>
            
            <div className='d-flex languages headerItemsMargin flex-row align-items-center'>
              <Dropdown id='language-dropdown'>
                <Dropdown.Toggle id='language-btn' className='languages-dropdown' 
                  aria-label={Translate("N_General_main_language_select")}
                  aria-controls="langList"
                  role="combobox"
                >
                  <img
                    src={globe}
                    alt=""
                    style={{ width: '16px', height: '16px' }}
                    className='header-icon bstrp-m-2'
                    aria-hidden="true"
                  />
                  <span>
                    {Translate(
                      `N_General_main_language_select_${selectedLang}`
                    )}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu id="langList" role="listbox">
                  {_siteSettings.langs.map((langName, index) => {
                    return (
                      <Dropdown.Item
                        id={`lang-item-${langName}`}
                        key={index}
                        eventKey={langName} 
                        role="option" 
                        active = {langName === selectedLang}                      
                        style={
                          langName === selectedLang
                            ? {
                                color: '#0068F5',
                              }
                            : { color: '#031147' }
                        }
                        onClick={() => {
                          changeLang(index);                          
                        }}
                      >
                        {Translate(
                          `N_General_main_language_select_${langName}`
                        )}
                        <img
                          src={checkMark}
                          alt=""
                          aria-hidden="true"
                          style={
                            langName === selectedLang
                              ? { display: 'inline-block' }
                              : { display: 'none' }
                          }
                        />
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div
              className='d-flex help flex-row align-items-center' 
              onClick={helpRedirect}
              onKeyPress={handleHelpKeyDown}
              tabIndex={0}                           
            >
              <img
                  src={lifeSaver}
                  alt=""
                  style={{ width: '16px', height: '16px' }}
                  className='header-icon bstrp-m-2'
                  aria-hidden="true"
                />
              <a className='help' >                                
                {Translate('N_General_Help')}
              </a>
            </div>
          </div>
        </div>
        <div>
        <div id='informationStreepDetails' className='informationBoxVisible informationBoxVisuallyHidden informationBoxHidden'>
            <div className='informationStreepDetails informationStreepDetailsDesktop'>               
                <div className='flexContainer'>
                  <div style={{width:'30%'}}></div>
                  <div className='informationBlockContainer'>
                    <div className='informationBlock' >
                        <img src={GovIlSite} alt="" aria-hidden="true"></img>
                        <div className='headerBlock'>{Translate(translateText[3].label)}</div>
                        <p>{Translate(translateText[4].label)}</p>
                    </div>
                    <div className='informationBlock' >
                        <img src={HttpsSite} alt="" aria-hidden="true"></img>
                        <div className='headerBlock'>{Translate(translateText[5].label)}</div>
                        <p>{Translate(translateText[6].label)} {Translate(translateText[7].label)} 
                          <img className='imgLock' src={Lock} alt="" aria-hidden="true"/>
                            {Translate(translateText[8].label)} <span>{Translate(translateText[9].label)}</span>
                        </p>
                    </div>
                    </div>
                    <div id="closeInformation" className="close-information">
                        <button type='button' id="btnCloseInfoStrip" className="close-information-icon" onClick={handleToggleClick} >
                            <img src={CloseX} alt={Translate("N_General_close")} ></img>
                        </button>
                        <span className="close-text" aria-hidden="true"><a onClick={handleToggleClick} style={{cursor: 'pointer'}}>{Translate("N_General_close")}</a></span>
                    </div>
                </div>
                
                <div className='ISwarning' >
                    <img src={OutlineCheckmarkCircle} alt="" aria-hidden="true" ></img> 
                    {Translate("N_General_system_security_info_3")}
                </div>
                <div id="closeInformationMobile" className="close-information">
                    <button className="close-information-icon" onClick={closeStrip}>
                        {Translate("N_General_system_security_info_butten")}
                    </button>                    
                </div>
            </div>
        </div>
        </div></div>
      </div>
      <div className='mobile'>
        <InformationStrip/>
        
        <div className='py-4 d-flex justify-content-between align-items-start header-dir'>
          <div className='mobile-menu-container'>
            <img
              src={hamburgerMenu}
              alt={Translate("N_General_Accessibility_Alt_Menu")}
              className='mobile-menu'
              onClick={toggleSlidingPane}
            />
          </div>
          <div className='logo-container'>                      
            <div>             
              <img src={logo}  alt={Translate("N_General_Accessibility_Alt_Logo")}/>              
            </div>
            <div>
              {Translate('N_General_system_title_1')}
            </div>
          </div>         
          <div className='d-flex languages flex-row align-items-center'>
            <Dropdown id='language-dropdown'>
              <Dropdown.Toggle id='language-btn' className='languages-dropdown' 
                aria-label={Translate("N_General_main_language_select")}
                aria-controls="langList"
                role="combobox"
              >
                <img
                  src={globe}
                  alt=""
                  style={{ width: '16px', height: '16px' }}
                  className='header-icon bstrp-m-1'
                  aria-hidden="true"
                />
                <span>
                  {Translate(
                    `N_General_main_language_select_${selectedLang}`
                  )}
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu id="langList" role="listbox">
                {_siteSettings.langs.map((langName, index) => {
                  return (
                    <Dropdown.Item
                      id={`lang-item-${langName}`}
                      key={index}
                      eventKey={langName} 
                      role="option" 
                      active = {langName === selectedLang}                      
                      style={
                        langName === selectedLang
                          ? {
                              color: '#0068F5',
                            }
                          : { color: '#031147' }
                      }
                      onClick={() => {
                        changeLang(index);                          
                      }}
                    >
                      {Translate(
                        `N_General_main_language_select_${langName}`
                      )}
                      <img
                        src={checkMark}
                        alt=""
                        aria-hidden="true"
                        style={
                          langName === selectedLang
                            ? { display: 'inline-block' }
                            : { display: 'none' }
                        }
                      />
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>                  
        
      </div>

      <SlidingPane
        className='sliding-pane-container'
        isOpen={isPaneOpen}
        shouldCloseOnEsc={true}
        closeIcon={<span></span>}
        onRequestClose={closeSlidingPane}
        from={_curLang === 'en' || _curLang === 'ru' ? 'left' : 'right'}
      >
        <SlidingPaneContent slidingPaneCallback={closeSlidingPane} />
      </SlidingPane>
    </div>
  );


};
export default Header;
